import { getAuthToken } from "../utils/authHelpers";
import { ROUTE_CONSTANT } from "../routes/constant";

export function getAuthConfig() {
  const token = getAuthToken();
  // If no token, redirect to login and return null to prevent API calls
  if (!token) {
    window.location.href = ROUTE_CONSTANT.AUTH.LOGIN;
    return null;
  }
  return {
    headers: {
      Authorization: token,
      "Content-Type": "application/json",
    },
  };
}

export function getFormDataConfig() {
  const token = getAuthToken();
  // If no token, redirect to login and return null to prevent API calls
  if (!token) {
    window.location.href = ROUTE_CONSTANT.AUTH.LOGIN;
    return null;
  }
  return {
    headers: {
      Authorization: token,
      "Content-Type": "multipart/form-data",
    },
  };
}

export function getConfig() {
  return {
    headers: {
      "Content-Type": "application/json",
    },
  };
}
